import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { NoTrustedDeviceComponent } from './trusted-devices/no-trusted-device/no-trusted-device.component';
import { GlobalDataLayerModule } from '@fedex/global-data-layer-client';
import { ProfileEditModule } from '../profile-edit/profile-edit.module';
import { AdaptiveMfaComponent } from './adaptive-mfa/adaptive-mfa.component';
import { TwoStepverificationComponent } from './two-stepverification/two-stepverification.component';
import { LoginCallFailureComponent } from 'src/app/shared/components/login-call-failure/login-call-failure.component';
import { ContinueConfirmationComponent } from './continue-confirmation-popup/continue-confirmation.component';
import { CanDeactivateGuard } from 'src/app/shared/guards/can-deactivate.guard';
import {
  CommunicationDevicesComputerIcon,
  CommunicationDevicesMobileIcon,
  TrashcanIcon,
  CrossIcon,
  IconModule,
  IconRegistry,
  UtilityCrossFatIcon,
  Popr2Module,
  CommonCoreModule,
  UtilityShowIcon,
  UtilityHideIcon,
  UtilityCheckmarkFatIcon
} from '@ciam/library';
import { TrustedDeviceComponent } from './trusted-devices/trusted-device.component';
import { DeviceTableComponent } from './trusted-devices/device-table/device-table.component';
import { RemoveTrustedDeviceComponent } from './trusted-devices/remove-trusted-device/remove-trusted-device.component';
import { TwoSteptogglePopupComponent } from './two-steptoggle-popup/two-steptoggle-popup.component';
import { StepUpComponent } from 'src/app/features/step-up/step-up.component';
import { VerificationMethodComponent } from 'src/app/features/step-up/verification-method/verification-method.component';
import { MethodListItemComponent } from 'src/app/features/step-up/verification-method/method-list-item/method-list-item.component';
import { OtpFormComponent } from 'src/app/features/step-up/otp-form/otp-form.component';


const routes: Routes = [
  { path: '', component: LoginComponent, canDeactivate: [CanDeactivateGuard] }
];
@NgModule({
  declarations: [
    LoginComponent,
    NoTrustedDeviceComponent,
    AdaptiveMfaComponent,
    TwoStepverificationComponent,
    LoginCallFailureComponent, ContinueConfirmationComponent, TrustedDeviceComponent, DeviceTableComponent, RemoveTrustedDeviceComponent, TwoSteptogglePopupComponent,
    StepUpComponent,
    VerificationMethodComponent,
    MethodListItemComponent,
    OtpFormComponent
  ],
  imports: [
    ProfileEditModule,
    CommonModule,
    CommonCoreModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    GlobalDataLayerModule,
    RouterModule.forChild(routes),
    IconModule,
    Popr2Module
  ],
  exports: [
    LoginComponent
  ]
})
export class LoginModule {
  constructor(private iconRegistry: IconRegistry) {
    this.iconRegistry.register(
      UtilityCrossFatIcon,
      UtilityCheckmarkFatIcon,
      UtilityShowIcon, 
      UtilityHideIcon,
      CrossIcon,
      CommunicationDevicesMobileIcon,
      CommunicationDevicesComputerIcon,
      TrashcanIcon
    );
  }
}
